import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#e9fcf8",
      d: "M0 8a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#3ccfb7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M24.5 10.85v5.4h-15v-5.4a.6.6 0 0 1 .6-.6h13.8a.6.6 0 0 1 .6.6M21.5 13.25h.75M9.5 16.25l.484 1.584a2 2 0 0 0 1.913 1.416h.603M24.5 16.25l-.484 1.584a2 2 0 0 1-1.913 1.416H21.5M15.125 18.875s0 5.25-2.625 5.25M18.875 18.875s0 5.25 2.625 5.25M17 18.875v5.25"
    }, null, -1)
  ]))]))
}
export default { render: render }